import { useContext } from "react"

import {
    CampaignDetailDispatchContext,
    CampaignDetailDispatchType,
    CampaignDetailStateContext,
    CampaignDetailStateType,
} from "./CampaignDetailContext.context"

export const useCampaignDetailStateContext = (): CampaignDetailStateType => {
    const context = useContext(CampaignDetailStateContext)
    if (context === undefined) {
        throw new Error("useCampaignDetailStateContext must be used within an CampaignDetailStateContext")
    }
    return context
}

export const useCampaignDetailDispatchContext = (): CampaignDetailDispatchType => {
    const context = useContext(CampaignDetailDispatchContext)
    if (context === undefined) {
        throw new Error("useCampaignDetailDispatchContext must be used within an CampaignDetailDispatchContext")
    }
    return context
}

export const useCampaignDetailContext = (): [CampaignDetailStateType, CampaignDetailDispatchType] => {
    return [useCampaignDetailStateContext(), useCampaignDetailDispatchContext()]
}
